
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill",attrs:{"d":"M22.0801 17.7269V2.32715C22.0801 1.77486 21.6324 1.32715 21.0801 1.32715H15.0792H10.7981H5.22669C4.67474 1.32715 4.22717 1.77433 4.22668 2.32628L4.21771 12.6283H1C0.447715 12.6283 0 13.076 0 13.6283V21.6724C0 22.2247 0.447715 22.6724 1 22.6724H4.68068C5.23296 22.6724 5.68068 22.2247 5.68068 21.6724V21.5922H22.0672C23.133 21.5922 24 20.7252 24 19.6595C24 18.598 23.1399 17.734 22.0801 17.7269ZM4.21274 15.2332V21.2044H1.46793V14.0962H4.21274V15.2332ZM12.2659 2.79508H13.6113V4.7432H12.2659V2.79508ZM5.69427 2.79508H10.7981V5.21114C10.7981 5.76342 11.2458 6.21114 11.7981 6.21114H14.0792C14.6315 6.21114 15.0792 5.76342 15.0792 5.21114V2.79508H20.6122V17.7267H13.0636C12.8932 17.7267 12.7546 17.5881 12.7546 17.4177C12.7546 17.2474 12.8932 17.1088 13.0636 17.1088H15.6912C16.8047 17.1088 17.7107 16.2028 17.7107 15.0893C17.7107 14.0949 16.9688 13.236 15.985 13.0913L13.6991 12.7552C11.5537 12.4397 10.194 12.7468 8.43556 13.4238L5.68396 14.6029L5.69427 2.79508ZM22.0672 20.1242H5.68068V18.0879L5.68265 16.2003L8.97575 14.7887C10.7704 14.099 11.8259 13.9632 13.4856 14.2073L15.7715 14.5434C16.0402 14.583 16.2428 14.8176 16.2428 15.0891C16.2428 15.3933 15.9954 15.6406 15.6912 15.6406H13.0636C12.0838 15.6406 11.2866 16.4377 11.2866 17.4175C11.2866 18.3973 12.0838 19.1944 13.0636 19.1944H22.0672C22.3235 19.1944 22.5321 19.403 22.5321 19.6593C22.532 19.9157 22.3235 20.1242 22.0672 20.1242Z","fill":"#262D33"}})])
          )
        }
      }
    